export default __webpack_public_path__ + "static/media/img3.0a9fcce1.jpg";